/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
import { HasHubReturnNextFragmentDoc } from '../../../../../vehicle-common/src/lib/utils/vehicleValidators.hook'
import { AdVehicleMarkerVehicleFragmentDoc } from '../MapMarkers/AdVehicleMarker/AdVehicleMarker.hook'
import { VehicleMarkerVehicleFragmentDoc } from '../MapMarkers/VehicleMarker/VehicleMarker.hook'
import { VehicleListOverlayVehicleFragmentDoc } from '../VehicleListOverlay/VehicleListOverlay.hook'
import { UseFollowVehicleFragmentDoc } from './hooks/useFollowVehicle.hook'
import { UseLocationSelectionVehicleFragmentDoc } from './hooks/useLocationSelection.hook'
import { UseRebalancingCircleVehicleFragmentDoc } from './hooks/useRebalancingCircle.hook'
import { FilterByBookableOptionVehicleFragmentDoc } from './utils/filterByBookableOption.hook'
import { FilterByNotBookableOptionVehicleFragmentDoc } from './utils/filterByNotBookableOption.hook'
export type HereMapViewVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  openedBy: Types.VehicleInteractionUserType | null
  isSelfDriving: boolean
  inService: boolean | null
  notInServiceReasons: Array<Types.NotInServiceReason> | null
  label: number | null
  totalWheelchairUsersInVehicle: number | null
  vehicleType: Types.VehicleType
  engineType: Types.VehicleEngineType | null
  highVoltageBatteryLevel: number | null
  interiorTemperature: number | null
  nextHubReturn: {
    __typename?: 'HubReturn'
    type: Types.HubReturnType
    scheduledArrival: string
    area: { __typename?: 'Area'; id: string } | null
  } | null
  latestLocation: {
    __typename?: 'VehicleLocation'
    heading: number | null
    timestamp: string | null
    location: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    } | null
  } | null
  nextWaypoint: {
    __typename?: 'Waypoint'
    visible: boolean
    waypointActions: Array<{
      __typename?: 'WaypointAction'
      kind: Types.WaypointActionKind
      reallocationRadius: number | null
    }>
    stop: {
      __typename?: 'Stop'
      routingLocation: {
        __typename?: 'Location'
        latitude: number
        longitude: number
      }
    } | null
  } | null
  currentlyLocatedInServiceBreakLocation: {
    __typename?: 'ServiceBreakLocation'
    id: string
  } | null
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    actions: Array<
      | {
          __typename: 'FccWaypointDeliveryAction'
          estimatedAt: string
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              wheelchair: boolean
            } | null
          } | null
        }
      | {
          __typename: 'FccWaypointHubReturnAction'
          isPlannedHubReturn: boolean
          reason: Types.FccWaypointHubReturnReason
          estimatedAt: string
        }
      | {
          __typename: 'FccWaypointPickupAction'
          estimatedAt: string
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              wheelchair: boolean
            } | null
          } | null
        }
      | { __typename: 'FccWaypointReallocationAction'; estimatedAt: string }
    >
  }> | null
  pooling: {
    __typename?: 'Pooling'
    reason: Types.PoolingReason | null
    connected: boolean | null
  } | null
  taskNotifications: {
    __typename?: 'TaskNotificationList'
    tasks: Array<
      | {
          __typename?: 'HubServiceNotification'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'IvcTaskNotification'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'PassengerAuthentificationFallbackRequestedNotification'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'PassengerUnbuckled'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'RoadBlockageTaskNotification'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'ShiftDeviationNotification'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopAccessibilityDownvotedByDrivers'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopActivationFailedNotification'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopAreaMissingActiveStopsNotification'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopDownVotedByDrivers'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopPotentiallyUnreachable'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopValidationFailed'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'TimeManagementNotification'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'TripPrebookingNoAssignment'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'VehicleAvailabilityNotification'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'VehicleIncidentNotification'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'VehicleSurveillanceNotification'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'VehicleWaypointAttendance'
          createdAt: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          id: string
          notificationType: Types.TaskNotificationType
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
    >
  } | null
  fccCurrentAdAlerts?: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename?: 'FccAdAlert'
      type: Types.FccAdAlertType
      status: Types.FccAdAlertStatus
      createdAt: string
      id: string
      assignee: { __typename?: 'BackofficeUser'; id: string } | null
    }>
  } | null
  fccHandledByOperator?: { __typename?: 'BackofficeUser'; id: string } | null
  fccHandledByOperatorDetails?: {
    __typename?: 'BackofficeUser'
    firstName: string
    lastName: string
  } | null
  ignition: {
    __typename?: 'Ignition'
    ignitionState: Types.IgnitionState | null
    updatedAt: string | null
  } | null
}

export const HereMapViewVehicleFragmentDoc = gql`
    fragment HereMapViewVehicle on Vehicle {
  id
  nextHubReturn {
    area {
      id
    }
  }
  latestLocation {
    location {
      latitude
      longitude
    }
  }
  ...HasHubReturnNext
  ...UseFollowVehicle
  ...UseRebalancingCircleVehicle
  ...UseLocationSelectionVehicle
  ...VehicleMarkerVehicle
  ...AdVehicleMarkerVehicle
  ...VehicleListOverlayVehicle
  ...FilterByNotBookableOptionVehicle
  ...FilterByBookableOptionVehicle
}
    ${HasHubReturnNextFragmentDoc}
${UseFollowVehicleFragmentDoc}
${UseRebalancingCircleVehicleFragmentDoc}
${UseLocationSelectionVehicleFragmentDoc}
${VehicleMarkerVehicleFragmentDoc}
${AdVehicleMarkerVehicleFragmentDoc}
${VehicleListOverlayVehicleFragmentDoc}
${FilterByNotBookableOptionVehicleFragmentDoc}
${FilterByBookableOptionVehicleFragmentDoc}`
